var lib_core     = require("lib-core");
var ui_extensions = require("ui-extensions");

var OptionsModel = function(options) {
    ui_extensions.AbstractUIModel.apply(this,arguments);

    this.title = this.value ("title", true);
    this.title("options");
    this.options = this.list("options", true);
    this.icon = this.value("icon", true);
    this.icon("icon-drawingaids.svg");

    this.focus = this.value("focus", true);
    this.visible = this.value("visible", true);
    this.draggable = this.value("draggable", true);
    this.location = this.value("location", true);
    this.location("top right");
    this.readOnly = this.value("readOnly", true);

    if(options) {
        if(options.draggable) this.draggable(options.draggable);
        if(options.icon) this.icon(options.icon);
        if(options.title) this.title(options.title);
        if(options.location) this.location(options.location)
    }
};

lib_core.inherit(OptionsModel, ui_extensions.AbstractUIModel);
OptionsModel.$class = "OptionsModel";

module.exports = OptionsModel;
